<template>
  <div style="height: 100%">
    <!-- 页面骨架:筛选区 + ve-table列表 + 新增编辑弹窗 + 初始密码弹窗 -->
    <div style="display: flex; width: 100%">
      <div style="width: 100%">
        <el-row class="filter-bar" ref="filterBar">
          <el-input v-model="formDatas.amsName" style="width: 160px" size="mini" placeholder="供货商名称"
            clearable></el-input>
          <el-select size="mini" v-model="formDatas.amsStatus" clearable placeholder="状态" style="width: 120px;" @change="partserch">
            <el-option label="正常" :value="1" key="s1"></el-option>
            <el-option label="禁用" :value="2" key="s2"></el-option>
          </el-select>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="">搜索</el-button>
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="openAdd">新增供货商</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            row-key-field-name="amsId" style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>

    <!-- 新增/编辑供货商弹窗 -->
    <el-dialog :title="edit ? '编辑供货商' : '新增供货商'" :visible.sync="dialog" width="600px"
      :close-on-click-modal="false" @closed="handleDialogClosed">
      <el-form ref="formRef" :model="form" label-width="130px" :rules="rules">
        <el-form-item label="供货商名称" prop="amsName">
          <el-input v-model.trim="form.amsName" maxlength="100" show-word-limit placeholder="请输入供货商名称(100字内)"></el-input>
        </el-form-item>
        <el-form-item label="登录账号" prop="amsAccount">
          <el-input v-model.trim="form.amsAccount" maxlength="50" placeholder="4-50位字母数字下划线,供货商后台登录用"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="amsRemark">
          <el-input type="textarea" :rows="3" maxlength="500" show-word-limit v-model="form.amsRemark"
            placeholder="请输入备注(选填)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="sureBtn">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 初始密码弹窗:新增/重置成功后展示,只显示这一次 -->
    <!-- 修复小f#6:禁用 ESC 关闭(遮罩与右上角叉已禁),防误关一次性密码弹窗 -->
    <el-dialog title="初始密码" :visible.sync="pwdDialog" width="440px" :close-on-click-modal="false"
      :show-close="false" :close-on-press-escape="false">
      <div style="text-align: center">
        <div style="font-size: 15px; margin-bottom: 12px">
          账号 <b>{{ pwdRow.amsAccount }}</b> 的初始密码：
        </div>
        <!-- 大号等宽字体展示,便于逐字符核对抄录 -->
        <div class="pwd-mono">
          {{ pwdValue }}
        </div>
        <el-alert title="初始密码仅此一次展示，请立即复制抄送供货商，并提醒其登录后尽快修改密码！"
          type="warning" :closable="false" show-icon></el-alert>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" plain @click="copyPwd">复制密码</el-button>
        <el-button type="primary" @click="pwdDialog = false">我已保存，关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import {
  getAjefMallSupplierList,
  addAjefMallSupplier,
  updateAjefMallSupplier,
  updateAjefMallSupplierStatus,
  resetAjefMallSupplierPassword,
} from "../../api/api";

export default {
  name: "MallSupplier",
  components: {},
  data() {
    return {
      tableLoading: false,
      submitLoading: false,
      totalCount: 0,
      tableHight: 520,
      tableData: [],
      formDatas: {
        amsName: "",
        amsStatus: "",
        currentPage: 1,
        pageSize: 10,
      },
      // 新增/编辑弹窗
      dialog: false,
      edit: false,
      form: {
        amsId: null,
        amsName: "",
        amsAccount: "",
        amsRemark: "",
      },
      rules: {
        amsName: [{ required: true, message: "请输入供货商名称", trigger: "blur" }],
        amsAccount: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
          // 与后端校验口径一致:4-50位字母数字下划线
          { pattern: /^[A-Za-z0-9_]{4,50}$/, message: "账号为4-50位字母数字下划线", trigger: "blur" },
        ],
      },
      // 初始密码弹窗(新增返回initPassword/重置返回newPassword)
      pwdDialog: false,
      pwdValue: "",
      pwdRow: {},
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "amsName",
          key: "amsName",
          title: "供货商名称",
          width: 200,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row }) => row.amsName || "-",
        },
        {
          field: "amsAccount",
          key: "amsAccount",
          title: "登录账号",
          width: 160,
          align: "center",
          renderBodyCell: ({ row }) => row.amsAccount || "-",
        },
        {
          field: "amsStatus",
          key: "amsStatus",
          title: "状态",
          width: 90,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            // 1正常 2禁用
            return h("el-tag", {
              props: { type: row.amsStatus === 1 ? "success" : "danger", size: "mini" },
            }, row.amsStatusDes || (row.amsStatus === 1 ? "正常" : "禁用"));
          },
        },
        {
          field: "amsRemark",
          key: "amsRemark",
          title: "备注",
          width: 200,
          align: "center",
          renderBodyCell: ({ row }) => row.amsRemark || "-",
        },
        { field: "createtime", key: "createtime", title: "创建时间", width: 170, align: "center" },
        { field: "updatetime", key: "updatetime", title: "更新时间", width: 170, align: "center" },
        {
          field: "operation",
          key: "operation",
          title: "操作",
          width: 210,
          align: "center",
          fixed: "right",
          renderBodyCell: ({ row }, h) => {
            const buttons = [
              h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#409EFF", padding: "0", marginRight: "10px" },
                on: { click: () => this.openEdit(row) },
              }, "编辑"),
            ];
            // 启用/禁用互斥按钮
            if (row.amsStatus === 1) {
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#F56C6C", padding: "0", marginRight: "10px" },
                on: { click: () => this.handleStatus(row, 2) },
              }, "禁用"));
            } else {
              buttons.push(h("el-button", {
                props: { type: "text", size: "mini" },
                style: { color: "#67C23A", padding: "0", marginRight: "10px" },
                on: { click: () => this.handleStatus(row, 1) },
              }, "启用"));
            }
            buttons.push(h("el-button", {
              props: { type: "text", size: "mini" },
              style: { color: "#E6A23C", padding: "0" },
              on: { click: () => this.handleResetPwd(row) },
            }, "重置密码"));
            return h("div", buttons);
          },
        },
      ],
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = calcTableHeight(this, this.windheight, 140);
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = calcTableHeight(this, val, 140);
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = calcTableHeight(this, this.windheight, 140);
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      getAjefMallSupplierList(this.formDatas).then((res) => {
        this.tableLoading = false;
        // 失败时拦截器已弹提示并返回undefined
        if (!res) {
          return;
        }
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    // 打开新增弹窗
    openAdd() {
      this.edit = false;
      this.dialog = true;
    },
    // 打开编辑弹窗(深拷贝避免直接改动行数据)
    openEdit(row) {
      this.edit = true;
      this.dialog = true;
      this.$nextTick(() => {
        this.form = {
          amsId: row.amsId,
          amsName: row.amsName,
          amsAccount: row.amsAccount,
          amsRemark: row.amsRemark,
        };
      });
    },
    handleDialogClosed() {
      this.$refs.formRef.resetFields();
      this.form = { amsId: null, amsName: "", amsAccount: "", amsRemark: "" };
    },
    // 提交新增/编辑
    sureBtn() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitLoading = true;
        const req = this.edit
          ? updateAjefMallSupplier(this.form)
          : addAjefMallSupplier(this.form);
        req.then((res) => {
          this.submitLoading = false;
          if (!res) {
            return;
          }
          this.dialog = false;
          this.getList();
          if (this.edit) {
            this.$message.success("修改成功");
          } else {
            // 新增成功:后端返回初始密码,只此一次,弹窗强提示(账号取自提交表单)
            this.showPwd(null, res.data, this.form);
          }
        }).catch(() => {
          this.submitLoading = false;
        });
      });
    },
    // 启用/禁用(禁用前强提示影响范围)
    handleStatus(row, amsStatus) {
      if (amsStatus === 2) {
        this.$confirm(
          "禁用后其商品不可上架、不可购买，已下单订单照常履约。确定禁用该供货商？",
          "禁用供货商",
          { type: "warning", confirmButtonText: "确定禁用", cancelButtonText: "取消" }
        ).then(() => {
          this.doStatus(row, amsStatus);
        }).catch(() => { });
      } else {
        this.$confirm("确定启用该供货商？启用后其商品可正常上架售卖。", "启用供货商", { type: "info" })
          .then(() => {
            this.doStatus(row, amsStatus);
          }).catch(() => { });
      }
    },
    doStatus(row, amsStatus) {
      updateAjefMallSupplierStatus({ amsId: row.amsId, amsStatus: amsStatus }).then((res) => {
        if (!res) {
          return;
        }
        this.$message.success(amsStatus === 1 ? "已启用" : "已禁用");
        this.getList();
      });
    },
    // 重置密码:确认后调用,新密码只返回一次
    handleResetPwd(row) {
      this.$confirm(
        "确定重置该供货商的登录密码？重置后旧密码立即失效。",
        "重置密码",
        { type: "warning", confirmButtonText: "确定重置", cancelButtonText: "取消" }
      ).then(() => {
        resetAjefMallSupplierPassword({ amsId: row.amsId }).then((res) => {
          if (!res) {
            return;
          }
          this.showPwd(row, res.data);
        });
      }).catch(() => { });
    },
    // 展示一次性密码(新增传form抄账号,重置传row)
    showPwd(row, data, form) {
      const account = form ? form.amsAccount : row.amsAccount;
      this.pwdRow = { amsAccount: account || "-" };
      this.pwdValue = (data && (data.initPassword || data.newPassword)) || "";
      this.pwdDialog = true;
    },
    // 复制密码(clipboard不可用时退回execCommand)
    copyPwd() {
      const text = this.pwdValue;
      const done = () => this.$message.success("已复制，请及时抄送给供货商");
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.copyByExecCommand(text, done));
      } else {
        this.copyByExecCommand(text, done);
      }
    },
    copyByExecCommand(text, done) {
      const input = document.createElement("textarea");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand("copy");
        done();
      } catch (e) {
        this.$message.warning("复制失败，请手动选中复制");
      }
      document.body.removeChild(input);
    },
  },
};
</script>

<style>
.table-header-cell-class {
  background: var(--bg-color) !important;
  color: var(--font-color) !important;
  border-right: 0px !important;
}

.ve-table-container {
  height: auto !important;
}

/* 初始密码展示:大号等宽字体,数字0/字母O等易混字符可逐位核对 */
.pwd-mono {
  font-family: "Courier New", Consolas, monospace;
  font-size: 24px;
  font-weight: bold;
  color: #f56c6c;
  letter-spacing: 3px;
  margin-bottom: 16px;
  user-select: all;
}
</style>
